import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import type { SwiperOptions } from "swiper/types";

const BREAKPOINTS = [
  { sliderSize: 3, minWidth: 900, maxWidth: 999999 },
  { sliderSize: 2, minWidth: 500, maxWidth: 900 },
  { sliderSize: 1, minWidth: 0, maxWidth: 500 },
];

@Component({
    selector: "app-life-cycle-slider",
    templateUrl: "./life-cycle-slider.component.html",
    styleUrls: ["./life-cycle-slider.component.scss"],
    standalone: false
})
export class LifeCycleSliderComponent implements OnInit, AfterViewInit {
  @ViewChild("swiper", { static: false }) swiperEl: ElementRef;
  @Input() items: { image: string; image_description: string }[];

  config: SwiperOptions = {
    slidesPerView: 3,
    spaceBetween: 0,
    pagination: true,
  };

  get slidesPerView(): number {
    let slider = document.getElementById("slider");
    if (!slider) return 3;
    let elWidth = document.getElementById("slider").clientWidth;
    return BREAKPOINTS.find(
      (bkpt) => bkpt.minWidth <= elWidth && bkpt.maxWidth > elWidth
    ).sliderSize;
  }

  get swiperActiveIndex(): number {
    const swiper = this.swiperEl?.nativeElement?.swiper;
    if (!swiper) return -1;
    return swiper.activeIndex;
  }

  get hideLeft(): boolean {
    return this.swiperActiveIndex == 0;
  }

  get hideRight(): boolean {
    const swiper = this.swiperEl?.nativeElement?.swiper;
    const slidesPerView = swiper?.params?.slidesPerView ?? 1;
    return (
      this.swiperActiveIndex >=
      this.items.length - (typeof slidesPerView === 'number' ? slidesPerView : 1)
    );
  }

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (this.swiperEl?.nativeElement && !this.swiperEl.nativeElement.swiper) {
      const config = { ...this.config, slidesPerView: this.slidesPerView };
      Object.assign(this.swiperEl.nativeElement, config);
      this.swiperEl.nativeElement.initialize();
    }
  }

  slideNext(): void {
    this.swiperEl?.nativeElement?.swiper?.slideNext();
  }

  slidePrev(): void {
    this.swiperEl?.nativeElement?.swiper?.slidePrev();
  }
}
